import { openInGmail, openInOutlook, openInMailto } from "@/lib/mailCompose";
import { Mail } from "lucide-react";

/**
 * Compact three-button row for opening a drafted pitch email in Gmail/Outlook/Mail app.
 * `email` may be either a string ("Subject: X\n\nBody...") or an object {subject, body}.
 */
export default function EmailComposeButtons({ email, toAddress = "", testIdPrefix = "compose", size = "sm" }) {
  const h = size === "lg" ? "h-11" : "h-9";
  const txt = size === "lg" ? "text-sm" : "text-xs";
  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={() => openInGmail(email, toAddress)}
        className={`sd-btn sd-btn-accent ${h} ${txt} px-3`}
        data-testid={`${testIdPrefix}-gmail-btn`}
      >
        <Mail size={12} strokeWidth={1.5} /> Gmail
      </button>
      <button
        onClick={() => openInOutlook(email, toAddress)}
        className={`sd-btn sd-btn-primary ${h} ${txt} px-3`}
        data-testid={`${testIdPrefix}-outlook-btn`}
      >
        <Mail size={12} strokeWidth={1.5} /> Outlook
      </button>
      <button
        onClick={() => openInMailto(email, toAddress)}
        className={`sd-btn sd-btn-ghost ${h} ${txt} px-3`}
        data-testid={`${testIdPrefix}-mailto-btn`}
      >
        Mail app
      </button>
    </div>
  );
}
